import {
  CategoryFacet,
  CategoryFacetValue,
  DateFacet,
  LocationFacet,
  NumericFacet,
  RegularFacet,
  RegularFacetValue,
} from '@coveo/headless/commerce';

export interface NewSearchFacetButtonViewModel {
  facetDisplayMessage: string;
  facet:
    | RegularFacet
    | CategoryFacet
    | NumericFacet
    | LocationFacet
    | DateFacet;
}

export interface ToggleFacetEvent {
  facet: RegularFacet | CategoryFacet;
  value: RegularFacetValue | CategoryFacetValue;
}

export enum FacetViewOperation {
  viewMore,
  viewLess,
}

export interface FacetViewEvent {
  facet: RegularFacet | CategoryFacet;
  operation: FacetViewOperation;
}

export const ListFacetFilterKey = {
  MY_LIST: 'shoppingListId',
  RECENT_PURCHASE: 'recentlyPurchasedListId',
};

export interface ListFacetValue {
  value: string;
  id: string;
  isSelected: boolean;
}

export class ListFacetSharedObject {
  public displayName: string;
  public isValuesSelected: boolean;
  public countValuesSelected: number;
  public values: Map<string, ListFacetValue> = new Map<
    string,
    ListFacetValue
  >();
}
